export enum TableSorting {
  ASC = 'ASC',
  DESC = 'DESC'
}
